import gql from 'graphql-tag';

import { QueryHookOptions } from '@apollo/client';
import { useLocalLazyQuery, useLocalQuery } from 'hooks/apollo';

export const dcisQuery = gql`
  query dcis($name: String) {
    dcis(name: $name) {
      count
      page
      data {
        id
        name
      }
    }
  }
`;

export const dcisQuery2 = gql`
  query {
    dcisCount {
      id
      name
      count
    }
  }
`;

export interface DCISData {
  count: number;
  page: number;
  data: {
    id: string;
    name: string;
    count: number;
  }[];
}

export const useDCIS = (options: QueryHookOptions<{ dcis: DCISData }, {}> = {}) => useLocalQuery(dcisQuery, options);
export const useCountedDCIS = (options: QueryHookOptions<{ dcisCount: DCISData }, {}> = {}) =>
  useLocalQuery(dcisQuery2, options);

export const useLazyDCIS = (options: QueryHookOptions<{ dcis: DCISData }, {}> = {}) =>
  useLocalLazyQuery(dcisQuery, options);

export const dciQuery = gql`
  query dci($id: ID!) {
    dci(id: $id) {
      id
      name
    }
  }
`;

export interface DCIData {
  id: string;
  name: string;
}

export const useDCI = (options: QueryHookOptions<{ dci: DCIData }, {}> = {}) => useLocalQuery(dciQuery, options);
